export default __webpack_public_path__ + "static/media/b34477759f95726b2a8b827033776d6c.gif";